import React, { Component } from 'react';
import logo from '../assets/img/airrefund.png';

export default class SuccessInfo extends Component {
  render(){
    return(
      <section>
        <div className="loa-signing">
            <img src={logo} alt="logo"/>
            <div className="loa-success-info">
              <span className="loa-success-info__title">
                {this.props.title}
              </span>
              <p className="loa-success-info__text">
                {this.props.text}
              </p>
            </div>
          </div>
      </section>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/SuccessInfo.js